import { Component, Vue } from "vue-property-decorator";
import { AxiosResponse } from "axios";

declare module "vue/types/vue" {
  interface Vue {
    cleanUpEmptyStrings(obj: any): any;
    isValidISODateTimeWithTimezone(dateValue?: string): boolean;
    downloadFile(response: AxiosResponse | undefined): void;
    buildAndDownloadFile(blobObj: Blob | undefined, filename: string): void;
  }
}

@Component
export default class VueMethods extends Vue {
  public cleanUpEmptyStrings(obj: Record<string, any>): Record<string, any> {
    const map = new Map(Object.entries(obj));
    map.forEach((value, key) => {
      if (value === "") {
        obj[key] = undefined;
      }
    });
    return obj;
  }

  public isValidISODateTimeWithTimezone(dateValue?: string): boolean {
    if (!dateValue) {
      return false;
    }

    const isoDateTimeWithTimezone =
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(Z|[+-]\d{2}:\d{2})$/;
    if (!isoDateTimeWithTimezone.test(dateValue)) {
      return false;
    }

    const parsedDate = new Date(dateValue);
    return !isNaN(parsedDate.getTime());
  }

  public downloadFile(response: AxiosResponse | undefined): void {
    const disposition = response?.headers["content-disposition"];
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition) ?? [];
    const filename = matches[1]?.replace(/['"]/g, "") ?? "";
    const blobObj = response?.data;
    this.buildAndDownloadFile(blobObj, filename);
  }

  public buildAndDownloadFile(blobObj: Blob | undefined, filename: string): void {
    if (blobObj) {
      const url = window.URL.createObjectURL(blobObj);
      const aElement = document.createElement("a");
      aElement.href = url;
      aElement.download = filename;
      document.body.appendChild(aElement);
      aElement.click();
      document.body.removeChild(aElement);
      window.URL.revokeObjectURL(url);
    }
  }
}
